const StayCategoryTabs = ({
  categories,
  activeId,
  onSelect,
  startingPrices,
  rateCounts,
}) => {
  if (!categories?.length) return null;

  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {categories.map((item) => {
        const isActive = activeId === item.id;
        const rateCount = rateCounts?.[item.id] ?? 0;
        const startingPrice = startingPrices?.[item.id] ?? 0;

        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onSelect(item.id)}
            className={`px-4 py-2.5 rounded-xl border text-left transition-all min-w-[140px] ${
              isActive
                ? "border-primary/40 bg-primary/5 shadow-sm"
                : "border-gray-100 bg-white hover:border-gray-200 hover:bg-slate-50/60"
            }`}
          >
            <div className="text-sm font-semibold text-gray-800">
              {item.stay_category.title}
            </div>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-xs text-gray-500">
                From ₹{startingPrice}/person
              </span>
              {rateCount > 0 && (
                <span className="text-xs bg-gray-100 px-1.5 py-0.5 rounded-full text-gray-600">
                  {rateCount} rates
                </span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default StayCategoryTabs;
